export async function wrapAsyncFn<T>(
  asyncFunc: () => Promise<T>,
  config: {
    before?: () => void;
    after?: () => void;
  }
): Promise<T> {
  const { before, after } = config;
  try {
    before?.();
    return await asyncFunc();
  } finally {
    after?.();
  }
}
